import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

const state = {
  allResourcesLoaded: false,
  // API data
  currentUser: null,
  currentCompany: null,
  companyGroups: [],
  companyPositions: [],
  userCompanies: [],
  userDepartments: [],
  // API loading states
  currentUserLoading: false,
  currentUserLoaded: false,
  currentCompanyLoading: false,
  currentCompanyLoaded: false,
  countryCodesLoaded: false,
  userCompaniesLoaded: false,
  companyGroupsLoaded: false,
  companyPositionsLoaded: false,
  // Locale state - timestamp to force getter re-computation
  contentLocaleTimestamp: Date.now(),
}

export default {
  state,
  getters,
  mutations,
  actions,
}
